module.exports = __webpack_public_path__ + "static/media/footer-bg.158da028.png";